var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0833 15.9579H3.50777C2.67555 15.9579 2 16.6217 2 17.4393C2 18.2558 2.67555 18.9206 3.50777 18.9206H10.0833C10.9155 18.9206 11.5911 18.2558 11.5911 17.4393C11.5911 16.6217 10.9155 15.9579 10.0833 15.9579Z",
    fill: "url(#paint0_linear_597_6054)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5899 6.37855C11.5899 5.56202 10.9144 4.89832 10.0833 4.89832H3.50777C2.67555 4.89832 2 5.56202 2 6.37855C2 7.19617 2.67555 7.85988 3.50777 7.85988H10.0833C10.9144 7.85988 11.5899 7.19617 11.5899 6.37855Z",
    fill: "url(#paint1_linear_597_6054)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8777 6.37838C21.8777 8.24505 20.3388 9.75803 18.4388 9.75803C16.5399 9.75803 14.9999 8.24505 14.9999 6.37838C14.9999 4.5128 16.5399 2.99982 18.4388 2.99982C20.3388 2.99982 21.8777 4.5128 21.8777 6.37838Z",
    fill: "url(#paint2_linear_597_6054)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 17.3992C22.0001 19.2648 20.4612 20.7778 18.5612 20.7778C16.6623 20.7778 15.1223 19.2648 15.1223 17.3992C15.1223 15.5325 16.6623 14.0196 18.5612 14.0196C20.4612 14.0196 22.0001 15.5325 22.0001 17.3992Z",
    fill: "url(#paint3_linear_597_6054)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_6054",
    x1: 2,
    y1: 15.9579,
    x2: 11.5523,
    y2: 19.0407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#799DFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_6054",
    x1: 2,
    y1: 4.89832,
    x2: 11.5507,
    y2: 7.98137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#799DFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_597_6054",
    x1: 15,
    y1: 2.99982,
    x2: 22.4863,
    y2: 3.75933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#799DFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_597_6054",
    x1: 15.1223,
    y1: 14.0196,
    x2: 22.6086,
    y2: 14.7791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#799DFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.4518b6b4883b36278471312d63de53cd.svg";
export { ForwardRef as ReactComponent };